/*
  Строка под кнопками загрузки: в скольких счетах человек в файле не совпадает
  с должником в системе (20.10.2026, вариант Б макета «1-fio-B»).

  Отдельной таблицы на экране загрузки нет - решение владельца: сами счета и
  пометки - в окне «Выбрать счета…», отбор «ФИО расходятся». Эта строка только
  говорит, что заглянуть туда стоит. Расхождений нет - строки нет.
*/

import { accountsPrepositional } from '../../api/format.js'

export function differing(choices) {
  return (choices ?? []).filter((choice) => choice.name_differs).length
}

export default function NameDifferences({ choices }) {
  const count = differing(choices)
  if (!count) return null
  return (
    <p className="picker-differences">
      В {accountsPrepositional(count)} человек в файле не совпадает с должником в системе.
      Посмотрите их в окне «Выбрать счета…», отбор «ФИО расходятся».
    </p>
  )
}
